import api from "helpers/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import endpoints from "helpers/endpoints";

const fetchAuditLogs = ({ queryKey }) => {
  const fetchOptions = queryKey[1];

  return api({
    method: "get",
    url: endpoints.AuditLogs,
    params: { ...fetchOptions },
    paramsSerializer: {
      indexes: null // by default: false
    }
  });
};

function useAuditLogs(fetchOptions) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["all-audit-logs", fetchOptions],
    queryFn: fetchAuditLogs,
    select: (data) => {
      if (data.data) {
        return data.data;
      } else {
        return { auditData: [], totalRecords: 0 };
      }
    },
    initialData: () => {
      return queryClient.getQueryData(["all-audit-logs"], {
        exact: false,
        type: "active"
      });
    },
    meta: {
      errorMessage: "E.AUDIT-001"
    },
    keepPreviousData: true
  });
}

const fetchEvent = () => {
  return api({
    url: endpoints.Events,
    method: "get"
  });
};

const useEvents = () => {
  return useQuery({
    queryKey: ["event-type"],
    queryFn: fetchEvent,
    select: (data): { id: number; name?: string }[] => data.data.events,
    meta: {
      errorMessage: "E.AUDIT-002"
    }
  });
};

export { useAuditLogs, useEvents };
